export const MINIMAL_CHROME_PARAM = 'chrome';
export const MINIMAL_CHROME_VALUE = 'minimal';
export const EMBEDDED_PARAM = 'embedded';
export const EMBEDDED_VALUE = '1';

export type EditorChromeMode = 'full' | 'minimal';

export function isMinimalEditorChrome(
  searchParams: URLSearchParams | { get(name: string): string | null }
): boolean {
  return searchParams.get(MINIMAL_CHROME_PARAM) === MINIMAL_CHROME_VALUE;
}

export function isEmbeddedEditor(
  searchParams: URLSearchParams | { get(name: string): string | null }
): boolean {
  return searchParams.get(EMBEDDED_PARAM) === EMBEDDED_VALUE;
}

/** Workspace iframe tabs and browser-tab editors must not render the host AppShell. */
export function shouldSkipAppShell(
  searchParams: URLSearchParams | { get(name: string): string | null }
): boolean {
  return isMinimalEditorChrome(searchParams) || isEmbeddedEditor(searchParams);
}

export function appendQueryFlag(href: string, key: string, value: string): string {
  const url = new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  url.searchParams.set(key, value);
  return `${url.pathname}${url.search}`;
}

export function appendChromeMinimal(href: string): string {
  return appendQueryFlag(href, MINIMAL_CHROME_PARAM, MINIMAL_CHROME_VALUE);
}

export function appendEmbedded(href: string): string {
  return appendQueryFlag(href, EMBEDDED_PARAM, EMBEDDED_VALUE);
}

export function resolveEditorChromeMode(
  searchParams: URLSearchParams,
  chromeProp?: EditorChromeMode
): EditorChromeMode {
  if (chromeProp) return chromeProp;
  return isMinimalEditorChrome(searchParams) ? 'minimal' : 'full';
}
